import React from 'react';
import { MDBIcon } from 'mdb-react-ui-kit';

interface WelcomeProps {
    setShowProjectDialog: (show : boolean) => void
}

const Welcome = (props :WelcomeProps) => {
    return (
        <div className='text-center w-100'>
            <br/> <br/> 
            <span className="help-info">Welcome to KONECT. Please start by creating/selecting a project! </span><br/>   
            <button onClick={() => { props.setShowProjectDialog(true) }}
                    type="button" className={"sidenav-create-button text-center"} style={{width: "auto"}} role="tab">
                    <span className="bs-stepper-label" style={{marginRight: "0.25rem", marginLeft: "0.5rem"}}>NEW PROJECT</span>
                    <span className="bs-stepper-circle">
                        <MDBIcon fas icon='plus' />
                    </span>
                </button>
        </div>
    );
};

export default Welcome;
